// ============================================================================
// SalesDayViewSwitcher.js — agora renderiza APENAS o Sales Day 2.0 (operacional
// + Modo Apresentação). A visão "Executiva" foi removida a pedido — o novo
// modelo de apresentação substituiu com folga.
// ============================================================================
import React from 'react';
import SalesDay2Dashboard from './SalesDay2Dashboard';

export default function SalesDayViewSwitcher() {
  return <SalesDay2Dashboard />;
}
